// Кодмод Фазы 1 миграции на Vite (13.08.2026): require('*.png') → ESM-импорты.
// Vite не исполняет CommonJS в браузере ('require is not defined'); webpack
// понимает ESM-импорты ассетов так же (asset/resource → URL-строка).
import img0 from '@images/UI/Outline/leaf/green.png';
import img1 from '@images/UI/Outline/leaf/green@2x.png';
import img2 from '@images/UI/Outline/leaf/green@3x.png';
import img3 from '@images/UI/Outline/leaf/red.png';
import img4 from '@images/UI/Outline/leaf/red@2x.png';
import img5 from '@images/UI/Outline/leaf/red@3x.png';
import img6 from '@images/UI/Outline/cash/contrast-grey.png';
import img7 from '@images/UI/Outline/cash/contrast-grey@2x.png';
import img8 from '@images/UI/Outline/cash/contrast-grey@3x.png';
import img9 from '@images/UI/Outline/fish/red.png';
import img10 from '@images/UI/Outline/fish/red@2x.png';
import img11 from '@images/UI/Outline/fish/red@3x.png';
import img12 from '@images/UI/Outline/fish/black.png';
import img13 from '@images/UI/Outline/fish/black@2x.png';
import img14 from '@images/UI/Outline/fish/black@3x.png';
import img15 from '@images/UI/Outline/bar/black.png';
import img16 from '@images/UI/Outline/bar/black@2x.png';
import img17 from '@images/UI/Outline/bar/black@3x.png';
import img18 from '@images/UI/Outline/funnel/black.png';
import img19 from '@images/UI/Outline/funnel/black@2x.png';
import img20 from '@images/UI/Outline/funnel/black@3x.png';
import img21 from '@images/UI/Outline/swap/black.png';
import img22 from '@images/UI/Outline/swap/black@2x.png';
import img23 from '@images/UI/Outline/swap/black@3x.png';
import img24 from '@images/UI/Outline/ruble/white.png';
import img25 from '@images/UI/Outline/ruble/white@2x.png';
import img26 from '@images/UI/Outline/ruble/white@3x.png';
import img27 from '@images/UI/Outline/arrow-left/darkGrey.png';
import img28 from '@images/UI/Outline/arrow-left/darkGrey@2x.png';
import img29 from '@images/UI/Outline/arrow-left/darkGrey@3x.png';
import img30 from '@images/UI/Outline/arrow-right/black.png';
import img31 from '@images/UI/Outline/arrow-right/black@2x.png';
import img32 from '@images/UI/Outline/arrow-right/black@3x.png';
import img33 from '@images/UI/Outline/ruble-circle/yellow.png';
import img34 from '@images/UI/Outline/ruble-circle/yellow@2x.png';
import img35 from '@images/UI/Outline/ruble-circle/yellow@3x.png';
import img36 from '@images/UI/Outline/arrow-long-2/red.png';
import img37 from '@images/UI/Outline/arrow-long-2/red@2x.png';
import img38 from '@images/UI/Outline/arrow-long-2/red@3x.png';
import img39 from '@images/UI/Outline/arrow-long-right/black.png';
import img40 from '@images/UI/Outline/arrow-long-right/black@2x.png';
import img41 from '@images/UI/Outline/arrow-long-right/black@3x.png';
import img42 from '@images/UI/Outline/arrow-long-right/yellow.png';
import img43 from '@images/UI/Outline/arrow-long-right/yellow@2x.png';
import img44 from '@images/UI/Outline/arrow-long-right/yellow@3x.png';
import img45 from '@images/UI/Outline/arrow-circle-down/black.png';
import img46 from '@images/UI/Outline/arrow-circle-down/black@2x.png';
import img47 from '@images/UI/Outline/arrow-circle-down/black@3x.png';
import img48 from '@images/UI/Outline/arrow-circle-down/red.png';
import img49 from '@images/UI/Outline/arrow-circle-down/red@2x.png';
import img50 from '@images/UI/Outline/arrow-circle-down/red@3x.png';
import img51 from '@images/UI/Outline/ng/white.png';
import img52 from '@images/UI/Outline/ng/white@2x.png';
import img53 from '@images/UI/Outline/ng/white@3x.png';
import img54 from '@images/UI/Outline/ng/black.png';
import img55 from '@images/UI/Outline/ng/black@2x.png';
import img56 from '@images/UI/Outline/ng/black@3x.png';
import img57 from '@images/UI/Outline/flip-2/black.png';
import img58 from '@images/UI/Outline/flip-2/black@2x.png';
import img59 from '@images/UI/Outline/flip-2/black@3x.png';
import img60 from '@images/UI/Outline/at/black.png';
import img61 from '@images/UI/Outline/at/black@2x.png';
import img62 from '@images/UI/Outline/at/black@3x.png';
import img63 from '@images/UI/Outline/print/black.png';
import img64 from '@images/UI/Outline/print/black@2x.png';
import img65 from '@images/UI/Outline/print/black@3x.png';
import img66 from '@images/UI/Outline/print/white.png';
import img67 from '@images/UI/Outline/print/white@2x.png';
import img68 from '@images/UI/Outline/print/white@3x.png';
import img69 from '@images/UI/Outline/copyFile/darkGrey.png';
import img70 from '@images/UI/Outline/copyFile/darkGrey@2x.png';
import img71 from '@images/UI/Outline/copyFile/darkGrey@3x.png';
import img72 from '@images/UI/Outline/maximize/white.png';
import img73 from '@images/UI/Outline/maximize/white@2x.png';
import img74 from '@images/UI/Outline/maximize/white@3x.png';
import img75 from '@images/UI/Outline/pause-circle/white.png';
import img76 from '@images/UI/Outline/pause-circle/white@2x.png';
import img77 from '@images/UI/Outline/pause-circle/white@3x.png';
import img78 from '@images/UI/Outline/play-circle/black.png';
import img79 from '@images/UI/Outline/play-circle/black@2x.png';
import img80 from '@images/UI/Outline/play-circle/black@3x.png';
import img81 from '@images/UI/Outline/play-circle/white.png';
import img82 from '@images/UI/Outline/play-circle/white@2x.png';
import img83 from '@images/UI/Outline/play-circle/white@3x.png';
import img84 from '@images/UI/Outline/list/black.png';
import img85 from '@images/UI/Outline/list/black@2x.png';
import img86 from '@images/UI/Outline/list/black@3x.png';
import img87 from '@images/UI/Outline/list/red.png';
import img88 from '@images/UI/Outline/list/red@2x.png';
import img89 from '@images/UI/Outline/list/red@3x.png';
import img90 from '@images/UI/Outline/video/white.png';
import img91 from '@images/UI/Outline/video/white@2x.png';
import img92 from '@images/UI/Outline/video/white@3x.png';
import img93 from '@images/UI/Outline/video/black.png';
import img94 from '@images/UI/Outline/video/black@2x.png';
import img95 from '@images/UI/Outline/video/black@3x.png';
import img96 from '@images/UI/Outline/video/red.png';
import img97 from '@images/UI/Outline/video/red@2x.png';
import img98 from '@images/UI/Outline/video/red@3x.png';
import img99 from '@images/UI/Outline/lock/midGrey.png';
import img100 from '@images/UI/Outline/lock/midGrey@2x.png';
import img101 from '@images/UI/Outline/lock/midGrey@3x.png';
import img102 from '@images/UI/Outline/crab/white.png';
import img103 from '@images/UI/Outline/crab/white@2x.png';
import img104 from '@images/UI/Outline/crab/white@3x.png';
import img105 from '@images/UI/Outline/crab/red.png';
import img106 from '@images/UI/Outline/crab/red@2x.png';
import img107 from '@images/UI/Outline/crab/red@3x.png';
import img108 from '@images/UI/Outline/all-done/black.png';
import img109 from '@images/UI/Outline/all-done/black@2x.png';
import img110 from '@images/UI/Outline/all-done/black@3x.png';
import img111 from '@images/UI/Outline/bell/black.png';
import img112 from '@images/UI/Outline/bell/black@2x.png';
import img113 from '@images/UI/Outline/bell/black@3x.png';
import img114 from '@images/UI/Outline/bell/midGrey.png';
import img115 from '@images/UI/Outline/bell/midGrey@2x.png';
import img116 from '@images/UI/Outline/bell/midGrey@3x.png';
import img117 from '@images/UI/Outline/bell/red.png';
import img118 from '@images/UI/Outline/bell/red@2x.png';
import img119 from '@images/UI/Outline/bell/red@3x.png';
import img120 from '@images/UI/Outline/bell/ultraDG.png';
import img121 from '@images/UI/Outline/bell/ultraDG@2x.png';
import img122 from '@images/UI/Outline/bell/ultraDG@3x.png';
import img123 from '@images/UI/Outline/fire/ultraDG.png';
import img124 from '@images/UI/Outline/fire/ultraDG@2x.png';
import img125 from '@images/UI/Outline/fire/ultraDG@3x.png';
import img126 from '@images/UI/Outline/qr/pink.png';
import img127 from '@images/UI/Outline/qr/pink@2x.png';
import img128 from '@images/UI/Outline/qr/pink@3x.png';
import img129 from '@images/UI/Outline/qr/black.png';
import img130 from '@images/UI/Outline/qr/black@2x.png';
import img131 from '@images/UI/Outline/qr/black@3x.png';
import img132 from '@images/UI/Outline/file-text/darkGrey.png';
import img133 from '@images/UI/Outline/file-text/darkGrey@2x.png';
import img134 from '@images/UI/Outline/file-text/darkGrey@3x.png';
import img135 from '@images/UI/Outline/file-text/black.png';
import img136 from '@images/UI/Outline/file-text/black@2x.png';
import img137 from '@images/UI/Outline/file-text/black@3x.png';
import img138 from '@images/UI/Outline/file-text/red.png';
import img139 from '@images/UI/Outline/file-text/red@2x.png';
import img140 from '@images/UI/Outline/file-text/red@3x.png';
import img141 from '@images/UI/Outline/file-text/white.png';
import img142 from '@images/UI/Outline/file-text/white@2x.png';
import img143 from '@images/UI/Outline/file-text/white@3x.png';
import img144 from '@images/UI/Outline/clipboard/pink.png';
import img145 from '@images/UI/Outline/clipboard/pink@2x.png';
import img146 from '@images/UI/Outline/clipboard/pink@3x.png';
import img147 from '@images/UI/Outline/person/pink.png';
import img148 from '@images/UI/Outline/person/pink@2x.png';
import img149 from '@images/UI/Outline/person/pink@3x.png';
import personMobileBlack from '@images/UI/Outline/person-mobile/black.png';
import personMobileBlack2x from '@images/UI/Outline/person-mobile/black@2x.png';
import personMobileBlack3x from '@images/UI/Outline/person-mobile/black@3x.png';
import personMobileGrey from '@images/UI/Outline/person-mobile/grey.png';
import personMobileGrey2x from '@images/UI/Outline/person-mobile/grey@2x.png';
import personMobileGrey3x from '@images/UI/Outline/person-mobile/grey@3x.png';
import personMobileFilled from '@images/UI/Outline/person-mobile/filled.png';
import personMobileFilled2x from '@images/UI/Outline/person-mobile/filled@2x.png';
import personMobileFilled3x from '@images/UI/Outline/person-mobile/filled@3x.png';
import personMobileActive from '@images/UI/Outline/person-mobile/active.png';
import personMobileActive2x from '@images/UI/Outline/person-mobile/active@2x.png';
import personMobileActive3x from '@images/UI/Outline/person-mobile/active@3x.png';
import personMobileGreyNotification from '@images/UI/Outline/person-mobile/grey-notification.png';
import personMobileGreyNotification2x from '@images/UI/Outline/person-mobile/grey-notification@2x.png';
import personMobileGreyNotification3x from '@images/UI/Outline/person-mobile/grey-notification@3x.png';
import personMobileBlackNotification from '@images/UI/Outline/person-mobile/black-notification.png';
import personMobileBlackNotification2x from '@images/UI/Outline/person-mobile/black-notification@2x.png';
import personMobileBlackNotification3x from '@images/UI/Outline/person-mobile/black-notification@3x.png';
import img150 from '@images/UI/Outline/person-done/black.png';
import img151 from '@images/UI/Outline/person-done/black@2x.png';
import img152 from '@images/UI/Outline/person-done/black@3x.png';
import img153 from '@images/UI/Outline/person-done/yellow.png';
import img154 from '@images/UI/Outline/person-done/yellow@2x.png';
import img155 from '@images/UI/Outline/person-done/yellow@3x.png';
import img156 from '@images/UI/Outline/cutlery/darkGrey.png';
import img157 from '@images/UI/Outline/cutlery/darkGrey@2x.png';
import img158 from '@images/UI/Outline/cutlery/darkGrey@3x.png';
import img159 from '@images/UI/Outline/percent/black.png';
import img160 from '@images/UI/Outline/percent/black@2x.png';
import img161 from '@images/UI/Outline/percent/black@3x.png';
import img162 from '@images/UI/Outline/percent/red.png';
import img163 from '@images/UI/Outline/percent/red@2x.png';
import img164 from '@images/UI/Outline/percent/red@3x.png';
import img165 from '@images/UI/Outline/percent/green.png';
import img166 from '@images/UI/Outline/percent/green@2x.png';
import img167 from '@images/UI/Outline/percent/green@3x.png';
import img168 from '@images/UI/Outline/percent/ultraDG.png';
import img169 from '@images/UI/Outline/percent/ultraDG@2x.png';
import img170 from '@images/UI/Outline/percent/ultraDG@3x.png';
import img171 from '@images/UI/Outline/briefcase/black.png';
import img172 from '@images/UI/Outline/briefcase/black@2x.png';
import img173 from '@images/UI/Outline/briefcase/black@3x.png';
import img174 from '@images/UI/Outline/question-mark-circle/white.png';
import img175 from '@images/UI/Outline/question-mark-circle/white@2x.png';
import img176 from '@images/UI/Outline/question-mark-circle/white@3x.png';
import img177 from '@images/UI/Outline/question-mark-circle/darkGrey.png';
import img178 from '@images/UI/Outline/question-mark-circle/darkGrey@2x.png';
import img179 from '@images/UI/Outline/question-mark-circle/darkGrey@3x.png';
import img180 from '@images/UI/Outline/question-mark-circle/midGrey.png';
import img181 from '@images/UI/Outline/question-mark-circle/midGrey@2x.png';
import img182 from '@images/UI/Outline/question-mark-circle/midGrey@3x.png';
import img183 from '@images/UI/Outline/question-mark-circle/black.png';
import img184 from '@images/UI/Outline/question-mark-circle/black@2x.png';
import img185 from '@images/UI/Outline/question-mark-circle/black@3x.png';
import img186 from '@images/UI/Outline/question-mark-circle/red.png';
import img187 from '@images/UI/Outline/question-mark-circle/red@2x.png';
import img188 from '@images/UI/Outline/question-mark-circle/red@3x.png';
import img189 from '@images/UI/Outline/chief-hat/white.png';
import img190 from '@images/UI/Outline/chief-hat/white@2x.png';
import img191 from '@images/UI/Outline/chief-hat/white@3x.png';
import img192 from '@images/UI/Outline/chief-hat/black.png';
import img193 from '@images/UI/Outline/chief-hat/black@2x.png';
import img194 from '@images/UI/Outline/chief-hat/black@3x.png';
import img195 from '@images/UI/Outline/chief-hat/red.png';
import img196 from '@images/UI/Outline/chief-hat/red@2x.png';
import img197 from '@images/UI/Outline/chief-hat/red@3x.png';
import img198 from '@images/UI/Outline/rotate-cw/black.png';
import img199 from '@images/UI/Outline/rotate-cw/black@2x.png';
import img200 from '@images/UI/Outline/rotate-cw/black@3x.png';
import img201 from '@images/UI/Outline/rotate-cw/red.png';
import img202 from '@images/UI/Outline/rotate-cw/red@2x.png';
import img203 from '@images/UI/Outline/rotate-cw/red@3x.png';
import img204 from '@images/UI/Outline/menu/white.png';
import img205 from '@images/UI/Outline/menu/white@2x.png';
import img206 from '@images/UI/Outline/menu/white@3x.png';
import img207 from '@images/UI/Outline/menu/black.png';
import img208 from '@images/UI/Outline/menu/black@2x.png';
import img209 from '@images/UI/Outline/menu/black@3x.png';
import img210 from '@images/UI/Outline/menu/ultraDG.png';
import img211 from '@images/UI/Outline/menu/ultraDG@2x.png';
import img212 from '@images/UI/Outline/menu/ultraDG@3x.png';
import img213 from '@images/UI/Outline/copy/black.png';
import img214 from '@images/UI/Outline/copy/black@2x.png';
import img215 from '@images/UI/Outline/copy/black@3x.png';
import img216 from '@images/UI/Outline/copy/red.png';
import img217 from '@images/UI/Outline/copy/red@2x.png';
import img218 from '@images/UI/Outline/copy/red@3x.png';
import img219 from '@images/UI/Outline/cube/white.png';
import img220 from '@images/UI/Outline/cube/white@2x.png';
import img221 from '@images/UI/Outline/cube/white@3x.png';
import img222 from '@images/UI/Outline/email/black.png';
import img223 from '@images/UI/Outline/email/black@2x.png';
import img224 from '@images/UI/Outline/email/black@3x.png';
import img225 from '@images/UI/Outline/email/white.png';
import img226 from '@images/UI/Outline/email/white@2x.png';
import img227 from '@images/UI/Outline/email/white@3x.png';
import img228 from '@images/UI/Outline/email/ultraDG.png';
import img229 from '@images/UI/Outline/email/ultraDG@2x.png';
import img230 from '@images/UI/Outline/email/ultraDG@3x.png';
import img231 from '@images/UI/Outline/review/ultraDG.png';
import img232 from '@images/UI/Outline/review/ultraDG@2x.png';
import img233 from '@images/UI/Outline/review/ultraDG@3x.png';
import img234 from '@images/UI/Outline/icecream/red.png';
import img235 from '@images/UI/Outline/icecream/red@2x.png';
import img236 from '@images/UI/Outline/icecream/red@3x.png';
import img237 from '@images/UI/Outline/icecream/ultraDG.png';
import img238 from '@images/UI/Outline/icecream/ultraDG@2x.png';
import img239 from '@images/UI/Outline/icecream/ultraDG@3x.png';
import img240 from '@images/UI/Outline/bookmark/black.png';
import img241 from '@images/UI/Outline/bookmark/black@2x.png';
import img242 from '@images/UI/Outline/bookmark/black@3x.png';
import img243 from '@images/UI/Outline/bookmark/white.png';
import img244 from '@images/UI/Outline/bookmark/white@2x.png';
import img245 from '@images/UI/Outline/bookmark/white@3x.png';
import img246 from '@images/UI/Outline/bookmark/grey.png';
import img247 from '@images/UI/Outline/bookmark/grey@2x.png';
import img248 from '@images/UI/Outline/bookmark/grey@3x.png';
import img249 from '@images/UI/Outline/bookmark/red.png';
import img250 from '@images/UI/Outline/bookmark/red@2x.png';
import img251 from '@images/UI/Outline/bookmark/red@3x.png';
import img252 from '@images/UI/Outline/bookmark/darkGrey.png';
import img253 from '@images/UI/Outline/bookmark/darkGrey@2x.png';
import img254 from '@images/UI/Outline/bookmark/darkGrey@3x.png';
import img255 from '@images/UI/Outline/heart/white.png';
import img256 from '@images/UI/Outline/heart/white@2x.png';
import img257 from '@images/UI/Outline/heart/white@3x.png';
import img258 from '@images/UI/Outline/heart/midGrey.png';
import img259 from '@images/UI/Outline/heart/midGrey@2x.png';
import img260 from '@images/UI/Outline/heart/midGrey@3x.png';
import img261 from '@images/UI/Outline/heart/pink.png';
import img262 from '@images/UI/Outline/heart/pink@2x.png';
import img263 from '@images/UI/Outline/heart/pink@3x.png';
import img264 from '@images/UI/Outline/heart/black.png';
import img265 from '@images/UI/Outline/heart/black@2x.png';
import img266 from '@images/UI/Outline/heart/black@3x.png';
import heartMobileBlack from '@images/UI/Outline/heart-mobile/black.png';
import heartMobileBlack2x from '@images/UI/Outline/heart-mobile/black@2x.png';
import heartMobileBlack3x from '@images/UI/Outline/heart-mobile/black@3x.png';
import heartMobileGrey from '@images/UI/Outline/heart-mobile/grey.png';
import heartMobileGrey2x from '@images/UI/Outline/heart-mobile/grey@2x.png';
import heartMobileGrey3x from '@images/UI/Outline/heart-mobile/grey@3x.png';
import heartMobileFilled from '@images/UI/Outline/heart-mobile/filled.png';
import heartMobileFilled2x from '@images/UI/Outline/heart-mobile/filled@2x.png';
import heartMobileFilled3x from '@images/UI/Outline/heart-mobile/filled@3x.png';
import heartMobileActive from '@images/UI/Outline/heart-mobile/active.png';
import heartMobileActive2x from '@images/UI/Outline/heart-mobile/active@2x.png';
import heartMobileActive3x from '@images/UI/Outline/heart-mobile/active@3x.png';
import img267 from '@images/UI/Outline/heart/red.png';
import img268 from '@images/UI/Outline/heart/red@2x.png';
import img269 from '@images/UI/Outline/heart/red@3x.png';
import img270 from '@images/UI/Outline/chevron-down/white.png';
import img271 from '@images/UI/Outline/chevron-down/white@2x.png';
import img272 from '@images/UI/Outline/chevron-down/white@3x.png';
import img273 from '@images/UI/Outline/chevron-down/black.png';
import img274 from '@images/UI/Outline/chevron-down/black@2x.png';
import img275 from '@images/UI/Outline/chevron-down/black@3x.png';
import img276 from '@images/UI/Outline/chevron-down/midGrey.png';
import img277 from '@images/UI/Outline/chevron-down/midGrey@2x.png';
import img278 from '@images/UI/Outline/chevron-down/midGrey@3x.png';
import img279 from '@images/UI/Outline/chevron-down/red.png';
import img280 from '@images/UI/Outline/chevron-down/red@2x.png';
import img281 from '@images/UI/Outline/chevron-down/red@3x.png';
import img282 from '@images/UI/Outline/chevron-down/darkGrey.png';
import img283 from '@images/UI/Outline/chevron-down/darkGrey@2x.png';
import img284 from '@images/UI/Outline/chevron-down/darkGrey@3x.png';
import img285 from '@images/UI/Outline/chevron-left/white.png';
import img286 from '@images/UI/Outline/chevron-left/white@2x.png';
import img287 from '@images/UI/Outline/chevron-left/white@3x.png';
import img288 from '@images/UI/Outline/chevron-left/black.png';
import img289 from '@images/UI/Outline/chevron-left/black@2x.png';
import img290 from '@images/UI/Outline/chevron-left/black@3x.png';
import img291 from '@images/UI/Outline/chevron-left/lightGrey.png';
import img292 from '@images/UI/Outline/chevron-left/lightGrey@2x.png';
import img293 from '@images/UI/Outline/chevron-left/lightGrey@3x.png';
import img294 from '@images/UI/Outline/chevron-left/red.png';
import img295 from '@images/UI/Outline/chevron-left/red@2x.png';
import img296 from '@images/UI/Outline/chevron-left/red@3x.png';
import img297 from '@images/UI/Outline/chevron-left/darkGrey.png';
import img298 from '@images/UI/Outline/chevron-left/darkGrey@2x.png';
import img299 from '@images/UI/Outline/chevron-left/darkGrey@3x.png';
import img300 from '@images/UI/Outline/chevron-right/white.png';
import img301 from '@images/UI/Outline/chevron-right/white@2x.png';
import img302 from '@images/UI/Outline/chevron-right/white@3x.png';
import img303 from '@images/UI/Outline/chevron-right/black.png';
import img304 from '@images/UI/Outline/chevron-right/black@2x.png';
import img305 from '@images/UI/Outline/chevron-right/black@3x.png';
import img306 from '@images/UI/Outline/chevron-right/lightGrey.png';
import img307 from '@images/UI/Outline/chevron-right/lightGrey@2x.png';
import img308 from '@images/UI/Outline/chevron-right/lightGrey@3x.png';
import img309 from '@images/UI/Outline/chevron-right/red.png';
import img310 from '@images/UI/Outline/chevron-right/red@2x.png';
import img311 from '@images/UI/Outline/chevron-right/red@3x.png';
import img312 from '@images/UI/Outline/chevron-right/darkGrey.png';
import img313 from '@images/UI/Outline/chevron-right/darkGrey@2x.png';
import img314 from '@images/UI/Outline/chevron-right/darkGrey@3x.png';
import img315 from '@images/UI/Outline/search/black.png';
import img316 from '@images/UI/Outline/search/black@2x.png';
import img317 from '@images/UI/Outline/search/black@3x.png';
import searchMobileBlack from '@images/UI/Outline/search-mobile/black.png';
import searchMobileBlack2x from '@images/UI/Outline/search-mobile/black@2x.png';
import searchMobileBlack3x from '@images/UI/Outline/search-mobile/black@3x.png';
import searchMobileGrey from '@images/UI/Outline/search-mobile/grey.png';
import searchMobileGrey2x from '@images/UI/Outline/search-mobile/grey@2x.png';
import searchMobileGrey3x from '@images/UI/Outline/search-mobile/grey@3x.png';
import searchMobileFilled from '@images/UI/Outline/search-mobile/filled.png';
import searchMobileFilled2x from '@images/UI/Outline/search-mobile/filled@2x.png';
import searchMobileFilled3x from '@images/UI/Outline/search-mobile/filled@3x.png';
import searchMobileActive from '@images/UI/Outline/search-mobile/active.png';
import searchMobileActive2x from '@images/UI/Outline/search-mobile/active@2x.png';
import searchMobileActive3x from '@images/UI/Outline/search-mobile/active@3x.png';
import img318 from '@images/UI/Outline/search/darkGrey.png';
import img319 from '@images/UI/Outline/search/darkGrey@2x.png';
import img320 from '@images/UI/Outline/search/darkGrey@3x.png';
import img321 from '@images/UI/Outline/search/red.png';
import img322 from '@images/UI/Outline/search/red@2x.png';
import img323 from '@images/UI/Outline/search/red@3x.png';
import img324 from '@images/UI/Outline/headphones/black.png';
import img325 from '@images/UI/Outline/headphones/black@2x.png';
import img326 from '@images/UI/Outline/headphones/black@3x.png';
import img327 from '@images/UI/Outline/home/black.png';
import img328 from '@images/UI/Outline/home/black@2x.png';
import img329 from '@images/UI/Outline/home/black@3x.png';
import homeMobileBlack from '@images/UI/Outline/home-mobile/black.png';
import homeMobileBlack2x from '@images/UI/Outline/home-mobile/black@2x.png';
import homeMobileBlack3x from '@images/UI/Outline/home-mobile/black@3x.png';
import homeMobileGrey from '@images/UI/Outline/home-mobile/grey.png';
import homeMobileGrey2x from '@images/UI/Outline/home-mobile/grey@2x.png';
import homeMobileGrey3x from '@images/UI/Outline/home-mobile/grey@3x.png';
import homeMobileFilled from '@images/UI/Outline/home-mobile/filled.png';
import homeMobileFilled2x from '@images/UI/Outline/home-mobile/filled@2x.png';
import homeMobileFilled3x from '@images/UI/Outline/home-mobile/filled@3x.png';
import homeMobileActive from '@images/UI/Outline/home-mobile/active.png';
import homeMobileActive2x from '@images/UI/Outline/home-mobile/active@2x.png';
import homeMobileActive3x from '@images/UI/Outline/home-mobile/active@3x.png';
import img330 from '@images/UI/Outline/home/contrast-grey.png';
import img331 from '@images/UI/Outline/home/contrast-grey@2x.png';
import img332 from '@images/UI/Outline/home/contrast-grey@3x.png';
import img333 from '@images/UI/Outline/gift/black.png';
import img334 from '@images/UI/Outline/gift/black@2x.png';
import img335 from '@images/UI/Outline/gift/black@3x.png';
import img336 from '@images/UI/Outline/gift/red.png';
import img337 from '@images/UI/Outline/gift/red@2x.png';
import img338 from '@images/UI/Outline/gift/red@3x.png';
import img339 from '@images/UI/Outline/knife/black.png';
import img340 from '@images/UI/Outline/knife/black@2x.png';
import img341 from '@images/UI/Outline/knife/black@3x.png';
import img342 from '@images/UI/Outline/grid3/black.png';
import img343 from '@images/UI/Outline/grid3/black@2x.png';
import img344 from '@images/UI/Outline/grid3/black@3x.png';
import gridMobileBlack from '@images/UI/Outline/grid-mobile/black.png';
import gridMobileBlack2x from '@images/UI/Outline/grid-mobile/black@2x.png';
import gridMobileBlack3x from '@images/UI/Outline/grid-mobile/black@3x.png';
import gridMobileGrey from '@images/UI/Outline/grid-mobile/grey.png';
import gridMobileGrey2x from '@images/UI/Outline/grid-mobile/grey@2x.png';
import gridMobileGrey3x from '@images/UI/Outline/grid-mobile/grey@3x.png';
import gridMobileFilled from '@images/UI/Outline/grid-mobile/filled.png';
import gridMobileFilled2x from '@images/UI/Outline/grid-mobile/filled@2x.png';
import gridMobileFilled3x from '@images/UI/Outline/grid-mobile/filled@3x.png';
import gridMobileActive from '@images/UI/Outline/grid-mobile/active.png';
import gridMobileActive2x from '@images/UI/Outline/grid-mobile/active@2x.png';
import gridMobileActive3x from '@images/UI/Outline/grid-mobile/active@3x.png';
import img345 from '@images/UI/Outline/grid3/ultraDG.png';
import img346 from '@images/UI/Outline/grid3/ultraDG@2x.png';
import img347 from '@images/UI/Outline/grid3/ultraDG@3x.png';
import img348 from '@images/UI/Outline/undo/black.png';
import img349 from '@images/UI/Outline/undo/black@2x.png';
import img350 from '@images/UI/Outline/undo/black@3x.png';
import img351 from '@images/UI/Outline/undo/darkGrey.png';
import img352 from '@images/UI/Outline/undo/darkGrey@2x.png';
import img353 from '@images/UI/Outline/undo/darkGrey@3x.png';
import img354 from '@images/UI/Outline/undo/red.png';
import img355 from '@images/UI/Outline/undo/red@2x.png';
import img356 from '@images/UI/Outline/undo/red@3x.png';
import img357 from '@images/UI/Outline/edit/red.png';
import img358 from '@images/UI/Outline/edit/red@2x.png';
import img359 from '@images/UI/Outline/edit/red@3x.png';
import img360 from '@images/UI/Outline/edit/black.png';
import img361 from '@images/UI/Outline/edit/black@2x.png';
import img362 from '@images/UI/Outline/edit/black@3x.png';
import img363 from '@images/UI/Outline/edit/green.png';
import img364 from '@images/UI/Outline/edit/green@2x.png';
import img365 from '@images/UI/Outline/edit/green@3x.png';
import img366 from '@images/UI/Outline/edit/darkGrey.png';
import img367 from '@images/UI/Outline/edit/darkGrey@2x.png';
import img368 from '@images/UI/Outline/edit/darkGrey@3x.png';
import img369 from '@images/UI/Outline/edit-2/black.png';
import img370 from '@images/UI/Outline/edit-2/black@2x.png';
import img371 from '@images/UI/Outline/edit-2/black@3x.png';
import img372 from '@images/UI/Outline/edit-2/red.png';
import img373 from '@images/UI/Outline/edit-2/red@2x.png';
import img374 from '@images/UI/Outline/edit-2/red@3x.png';
import img375 from '@images/UI/Outline/trash-2/black.png';
import img376 from '@images/UI/Outline/trash-2/black@2x.png';
import img377 from '@images/UI/Outline/trash-2/black@3x.png';
import img378 from '@images/UI/Outline/trash-2/darkGrey.png';
import img379 from '@images/UI/Outline/trash-2/darkGrey@2x.png';
import img380 from '@images/UI/Outline/trash-2/darkGrey@3x.png';
import img381 from '@images/UI/Outline/trash-2/red.png';
import img382 from '@images/UI/Outline/trash-2/red@2x.png';
import img383 from '@images/UI/Outline/trash-2/red@3x.png';
import img384 from '@images/UI/Outline/trash-2/grey.png';
import img385 from '@images/UI/Outline/trash-2/grey@2x.png';
import img386 from '@images/UI/Outline/trash-2/grey@3x.png';
import img387 from '@images/UI/Outline/trash-2/ultraDG.png';
import img388 from '@images/UI/Outline/trash-2/ultraDG@2x.png';
import img389 from '@images/UI/Outline/trash-2/ultraDG@3x.png';
import img390 from '@images/UI/Outline/star/black.png';
import img391 from '@images/UI/Outline/star/black@2x.png';
import img392 from '@images/UI/Outline/star/black@3x.png';
import img393 from '@images/UI/Outline/star/darkGrey.png';
import img394 from '@images/UI/Outline/star/darkGrey@2x.png';
import img395 from '@images/UI/Outline/star/darkGrey@3x.png';
import img396 from '@images/UI/Outline/star/red.png';
import img397 from '@images/UI/Outline/star/red@2x.png';
import img398 from '@images/UI/Outline/star/red@3x.png';
import img399 from '@images/UI/Outline/refresh/pink.png';
import img400 from '@images/UI/Outline/refresh/pink@2x.png';
import img401 from '@images/UI/Outline/refresh/pink@3x.png';
import img402 from '@images/UI/Outline/refresh/black.png';
import img403 from '@images/UI/Outline/refresh/black@2x.png';
import img404 from '@images/UI/Outline/refresh/black@3x.png';
import img405 from '@images/UI/Outline/refresh/darkGrey.png';
import img406 from '@images/UI/Outline/refresh/darkGrey@2x.png';
import img407 from '@images/UI/Outline/refresh/darkGrey@3x.png';
import img408 from '@images/UI/Outline/refresh/white.png';
import img409 from '@images/UI/Outline/refresh/white@2x.png';
import img410 from '@images/UI/Outline/refresh/white@3x.png';
import img411 from '@images/UI/Outline/minus/udg.png';
import img412 from '@images/UI/Outline/minus/udg@2x.png';
import img413 from '@images/UI/Outline/minus/udg@3x.png';
import img414 from '@images/UI/Outline/minus/white.png';
import img415 from '@images/UI/Outline/minus/white@2x.png';
import img416 from '@images/UI/Outline/minus/white@3x.png';
import img417 from '@images/UI/Outline/minus/black.png';
import img418 from '@images/UI/Outline/minus/black@2x.png';
import img419 from '@images/UI/Outline/minus/black@3x.png';
import img420 from '@images/UI/Outline/plus/black.png';
import img421 from '@images/UI/Outline/plus/black@3x.png';
import img422 from '@images/UI/Outline/plus/black@2x.png';
import img423 from '@images/UI/Outline/plus/darkGrey.png';
import img424 from '@images/UI/Outline/plus/darkGrey@3x.png';
import img425 from '@images/UI/Outline/plus/darkGrey@2x.png';
import img426 from '@images/UI/Outline/plus/darkRed.png';
import img427 from '@images/UI/Outline/plus/darkRed@2x.png';
import img428 from '@images/UI/Outline/plus/darkRed@3x.png';
import img429 from '@images/UI/Outline/plus/white.png';
import img430 from '@images/UI/Outline/plus/white@2x.png';
import img431 from '@images/UI/Outline/plus/white@3x.png';
import img432 from '@images/UI/Outline/send/white.png';
import img433 from '@images/UI/Outline/send/white@2x.png';
import img434 from '@images/UI/Outline/send/white@3x.png';
import img435 from '@images/UI/Outline/camera/darkGrey.png';
import img436 from '@images/UI/Outline/camera/darkGrey@2x.png';
import img437 from '@images/UI/Outline/camera/darkGrey@3x.png';
import img438 from '@images/UI/Outline/camera/white.png';
import img439 from '@images/UI/Outline/camera/white@2x.png';
import img440 from '@images/UI/Outline/camera/white@3x.png';
import img441 from '@images/UI/Outline/eye-off-2/white.png';
import img442 from '@images/UI/Outline/eye-off-2/white@2x.png';
import img443 from '@images/UI/Outline/eye-off-2/white@3x.png';
import img444 from '@images/UI/Outline/eye/midGrey.png';
import img445 from '@images/UI/Outline/eye/midGrey@2x.png';
import img446 from '@images/UI/Outline/eye/midGrey@3x.png';
import img447 from '@images/UI/Outline/eye/black.png';
import img448 from '@images/UI/Outline/eye/black@2x.png';
import img449 from '@images/UI/Outline/eye/black@3x.png';
import img450 from '@images/UI/Outline/eye/red.png';
import img451 from '@images/UI/Outline/eye/red@2x.png';
import img452 from '@images/UI/Outline/eye/red@3x.png';
import img453 from '@images/UI/Outline/eye-off/midGrey.png';
import img454 from '@images/UI/Outline/eye-off/midGrey@2x.png';
import img455 from '@images/UI/Outline/eye-off/midGrey@3x.png';
import img456 from '@images/UI/Outline/close/red.png';
import img457 from '@images/UI/Outline/close/red@2x.png';
import img458 from '@images/UI/Outline/close/red@3x.png';
import img459 from '@images/UI/Outline/close/midGrey.png';
import img460 from '@images/UI/Outline/close/midGrey@2x.png';
import img461 from '@images/UI/Outline/close/midGrey@3x.png';
import img462 from '@images/UI/Outline/close/white.png';
import img463 from '@images/UI/Outline/close/white@2x.png';
import img464 from '@images/UI/Outline/close/white@3x.png';
import img465 from '@images/UI/Outline/close/darkGrey.png';
import img466 from '@images/UI/Outline/close/darkGrey@2x.png';
import img467 from '@images/UI/Outline/close/darkGrey@3x.png';
import img468 from '@images/UI/Outline/info/white.png';
import img469 from '@images/UI/Outline/info/white@2x.png';
import img470 from '@images/UI/Outline/info/white@3x.png';
import img471 from '@images/UI/Outline/info/pink.png';
import img472 from '@images/UI/Outline/info/pink@2x.png';
import img473 from '@images/UI/Outline/info/pink@3x.png';
import img474 from '@images/UI/Outline/info/red.png';
import img475 from '@images/UI/Outline/info/red@2x.png';
import img476 from '@images/UI/Outline/info/red@3x.png';
import img477 from '@images/UI/Outline/info/darkRed.png';
import img478 from '@images/UI/Outline/info/darkRed@2x.png';
import img479 from '@images/UI/Outline/info/darkRed@3x.png';
import img480 from '@images/UI/Outline/info/black.png';
import img481 from '@images/UI/Outline/info/black@2x.png';
import img482 from '@images/UI/Outline/info/black@3x.png';
import img483 from '@images/UI/Outline/bonus/pink.png';
import img484 from '@images/UI/Outline/bonus/pink@2x.png';
import img485 from '@images/UI/Outline/bonus/pink@3x.png';
import img486 from '@images/UI/Outline/bonus/red.png';
import img487 from '@images/UI/Outline/bonus/red@2x.png';
import img488 from '@images/UI/Outline/bonus/red@3x.png';
import img489 from '@images/UI/Outline/bonus/darkRed.png';
import img490 from '@images/UI/Outline/bonus/darkRed@2x.png';
import img491 from '@images/UI/Outline/bonus/darkRed@3x.png';
import img492 from '@images/UI/Outline/bonus/black.png';
import img493 from '@images/UI/Outline/bonus/black@2x.png';
import img494 from '@images/UI/Outline/bonus/black@3x.png';
import img495 from '@images/UI/Outline/bonus/white.png';
import img496 from '@images/UI/Outline/bonus/white@2x.png';
import img497 from '@images/UI/Outline/bonus/white@3x.png';
import img498 from '@images/UI/Outline/bonus/gold.png';
import img499 from '@images/UI/Outline/bonus/gold@2x.png';
import img500 from '@images/UI/Outline/bonus/gold@3x.png';
import img501 from '@images/UI/Outline/shield/gold.png';
import img502 from '@images/UI/Outline/shield/gold@2x.png';
import img503 from '@images/UI/Outline/shield/gold@3x.png';
import img504 from '@images/UI/Outline/shield/black.png';
import img505 from '@images/UI/Outline/shield/black@2x.png';
import img506 from '@images/UI/Outline/shield/black@3x.png';
import img507 from '@images/UI/Outline/arrow-down/black.png';
import img508 from '@images/UI/Outline/arrow-down/black@2x.png';
import img509 from '@images/UI/Outline/arrow-down/black@3x.png';
import img510 from '@images/UI/Outline/arrow-ios-left/midGrey.png';
import img511 from '@images/UI/Outline/arrow-ios-left/midGrey@2x.png';
import img512 from '@images/UI/Outline/arrow-ios-left/midGrey@3x.png';
import img513 from '@images/UI/Outline/arrow-ios-left/red.png';
import img514 from '@images/UI/Outline/arrow-ios-left/red@2x.png';
import img515 from '@images/UI/Outline/arrow-ios-left/red@3x.png';
import img516 from '@images/UI/Outline/arrow-ios-left/lightGrey.png';
import img517 from '@images/UI/Outline/arrow-ios-left/lightGrey@2x.png';
import img518 from '@images/UI/Outline/arrow-ios-left/lightGrey@3x.png';
import img519 from '@images/UI/Outline/arrow-ios-left/black.png';
import img520 from '@images/UI/Outline/arrow-ios-left/black@2x.png';
import img521 from '@images/UI/Outline/arrow-ios-left/black@3x.png';
import img522 from '@images/UI/Outline/arrow-ios-right/midGrey.png';
import img523 from '@images/UI/Outline/arrow-ios-right/midGrey@2x.png';
import img524 from '@images/UI/Outline/arrow-ios-right/midGrey@3x.png';
import img525 from '@images/UI/Outline/arrow-ios-right/red.png';
import img526 from '@images/UI/Outline/arrow-ios-right/red@2x.png';
import img527 from '@images/UI/Outline/arrow-ios-right/red@3x.png';
import img528 from '@images/UI/Outline/arrow-ios-right/lightGrey.png';
import img529 from '@images/UI/Outline/arrow-ios-right/lightGrey@2x.png';
import img530 from '@images/UI/Outline/arrow-ios-right/lightGrey@3x.png';
import img531 from '@images/UI/Outline/arrow-ios-right/black.png';
import img532 from '@images/UI/Outline/arrow-ios-right/black@2x.png';
import img533 from '@images/UI/Outline/arrow-ios-right/black@3x.png';
import img534 from '@images/UI/Outline/arrow-ios-right/violet.png';
import img535 from '@images/UI/Outline/arrow-ios-right/violet@2x.png';
import img536 from '@images/UI/Outline/arrow-ios-right/violet@3x.png';
import img537 from '@images/UI/Outline/alert-triangle/black.png';
import img538 from '@images/UI/Outline/alert-triangle/black@2x.png';
import img539 from '@images/UI/Outline/alert-triangle/black@3x.png';
import img540 from '@images/UI/Outline/alert-circle/black.png';
import img541 from '@images/UI/Outline/alert-circle/black@2x.png';
import img542 from '@images/UI/Outline/alert-circle/black@3x.png';
import img543 from '@images/UI/Outline/share/red.png';
import img544 from '@images/UI/Outline/share/red@2x.png';
import img545 from '@images/UI/Outline/share/red@3x.png';
import img546 from '@images/UI/Outline/share/darkGrey.png';
import img547 from '@images/UI/Outline/share/darkGrey@2x.png';
import img548 from '@images/UI/Outline/share/darkGrey@3x.png';
import img549 from '@images/UI/Outline/share/black.png';
import img550 from '@images/UI/Outline/share/black@2x.png';
import img551 from '@images/UI/Outline/share/black@3x.png';
import img552 from '@images/UI/Outline/share/white.png';
import img553 from '@images/UI/Outline/share/white@2x.png';
import img554 from '@images/UI/Outline/share/white@3x.png';
import img555 from '@images/UI/Outline/shopping-cart/black.png';
import img556 from '@images/UI/Outline/shopping-cart/black@2x.png';
import img557 from '@images/UI/Outline/shopping-cart/black@3x.png';
import shoppingCartMobileBlack from '@images/UI/Outline/shopping-cart-mobile/black.png';
import shoppingCartMobileBlack2x from '@images/UI/Outline/shopping-cart-mobile/black@2x.png';
import shoppingCartMobileBlack3x from '@images/UI/Outline/shopping-cart-mobile/black@3x.png';
import shoppingCartMobileGrey from '@images/UI/Outline/shopping-cart-mobile/grey.png';
import shoppingCartMobileGrey2x from '@images/UI/Outline/shopping-cart-mobile/grey@2x.png';
import shoppingCartMobileGrey3x from '@images/UI/Outline/shopping-cart-mobile/grey@3x.png';
import shoppingCartMobileFilled from '@images/UI/Outline/shopping-cart-mobile/filled.png';
import shoppingCartMobileFilled2x from '@images/UI/Outline/shopping-cart-mobile/filled@2x.png';
import shoppingCartMobileFilled3x from '@images/UI/Outline/shopping-cart-mobile/filled@3x.png';
import shoppingCartMobileActive from '@images/UI/Outline/shopping-cart-mobile/active.png';
import shoppingCartMobileActive2x from '@images/UI/Outline/shopping-cart-mobile/active@2x.png';
import shoppingCartMobileActive3x from '@images/UI/Outline/shopping-cart-mobile/active@3x.png';
import img558 from '@images/UI/Outline/shopping-cart/ultraDG.png';
import img559 from '@images/UI/Outline/shopping-cart/ultraDG@2x.png';
import img560 from '@images/UI/Outline/shopping-cart/ultraDG@3x.png';
import img561 from '@images/UI/Outline/broccoli/ultraDG.png';
import img562 from '@images/UI/Outline/broccoli/ultraDG@2x.png';
import img563 from '@images/UI/Outline/broccoli/ultraDG@3x.png';
import img564 from '@images/UI/Outline/pin/black.png';
import img565 from '@images/UI/Outline/pin/black@2x.png';
import img566 from '@images/UI/Outline/pin/black@3x.png';
import img567 from '@images/UI/Outline/pin/white.png';
import img568 from '@images/UI/Outline/pin/white@2x.png';
import img569 from '@images/UI/Outline/pin/white@3x.png';
import img570 from '@images/UI/Outline/clock/black.png';
import img571 from '@images/UI/Outline/clock/black@2x.png';
import img572 from '@images/UI/Outline/clock/black@3x.png';
import img573 from '@images/UI/Outline/clock/red.png';
import img574 from '@images/UI/Outline/clock/red@2x.png';
import img575 from '@images/UI/Outline/clock/red@3x.png';
import img576 from '@images/UI/Outline/clock/contrast-grey.png';
import img577 from '@images/UI/Outline/clock/contrast-grey@2x.png';
import img578 from '@images/UI/Outline/clock/contrast-grey@3x.png';
import img579 from '@images/UI/Outline/timer/black.png';
import img580 from '@images/UI/Outline/timer/black@2x.png';
import img581 from '@images/UI/Outline/timer/black@3x.png';
import img582 from '@images/UI/Outline/award/black.png';
import img583 from '@images/UI/Outline/award/black@2x.png';
import img584 from '@images/UI/Outline/award/black@3x.png';
import img585 from '@images/UI/Outline/phone-call/pink.png';
import img586 from '@images/UI/Outline/phone-call/pink@2x.png';
import img587 from '@images/UI/Outline/phone-call/pink@3x.png';
import img588 from '@images/UI/Outline/phone-call/black.png';
import img589 from '@images/UI/Outline/phone-call/black@2x.png';
import img590 from '@images/UI/Outline/phone-call/black@3x.png';
import img591 from '@images/UI/Outline/reactions/smiled/red.png';
import img592 from '@images/UI/Outline/reactions/smiled/red@2x.png';
import img593 from '@images/UI/Outline/reactions/smiled/red@3x.png';
import img594 from '@images/UI/Outline/reactions/smiled/black.png';
import img595 from '@images/UI/Outline/reactions/smiled/black@2x.png';
import img596 from '@images/UI/Outline/reactions/smiled/black@3x.png';
import img597 from '@images/UI/Outline/smartphone/black.png';
import img598 from '@images/UI/Outline/smartphone/black@2x.png';
import img599 from '@images/UI/Outline/smartphone/black@3x.png';
import img600 from '@images/UI/Outline/smartphone/yellow.png';
import img601 from '@images/UI/Outline/smartphone/yellow@2x.png';
import img602 from '@images/UI/Outline/smartphone/yellow@3x.png';
import img603 from '@images/UI/Outline/calendar/black.png';
import img604 from '@images/UI/Outline/calendar/black@2x.png';
import img605 from '@images/UI/Outline/calendar/black@3x.png';
import img606 from '@images/UI/Outline/calendar/midGrey.png';
import img607 from '@images/UI/Outline/calendar/midGrey@2x.png';
import img608 from '@images/UI/Outline/calendar/midGrey@3x.png';
import img609 from '@images/UI/Outline/calendar/white.png';
import img610 from '@images/UI/Outline/calendar/white@2x.png';
import img611 from '@images/UI/Outline/calendar/white@3x.png';
import img612 from '@images/UI/Outline/car/red.png';
import img613 from '@images/UI/Outline/car/red@2x.png';
import img614 from '@images/UI/Outline/car/red@3x.png';
import img615 from '@images/UI/Outline/car/black.png';
import img616 from '@images/UI/Outline/car/black@2x.png';
import img617 from '@images/UI/Outline/car/black@3x.png';
import img618 from '@images/UI/Outline/inbox/red.png';
import img619 from '@images/UI/Outline/inbox/red@2x.png';
import img620 from '@images/UI/Outline/inbox/red@3x.png';
import img621 from '@images/UI/Outline/inbox/black.png';
import img622 from '@images/UI/Outline/inbox/black@2x.png';
import img623 from '@images/UI/Outline/inbox/black@3x.png';
import img624 from '@images/UI/Outline/checkmark-circle/red.png';
import img625 from '@images/UI/Outline/checkmark-circle/red@2x.png';
import img626 from '@images/UI/Outline/checkmark-circle/red@3x.png';
import img627 from '@images/UI/Outline/checkmark-circle/black.png';
import img628 from '@images/UI/Outline/checkmark-circle/black@2x.png';
import img629 from '@images/UI/Outline/checkmark-circle/black@3x.png';
import img630 from '@images/UI/Outline/checkmark-bold/violet.png';
import img631 from '@images/UI/Outline/checkmark-bold/violet@2x.png';
import img632 from '@images/UI/Outline/checkmark-bold/violet@3x.png';
import img633 from '@images/UI/Outline/checkmark/violet.png';
import img634 from '@images/UI/Outline/checkmark/violet@2x.png';
import img635 from '@images/UI/Outline/checkmark/violet@3x.png';
import img636 from '@images/UI/Outline/checkmark/darkGrey.png';
import img637 from '@images/UI/Outline/checkmark/darkGrey@2x.png';
import img638 from '@images/UI/Outline/checkmark/darkGrey@3x.png';
import img639 from '@images/UI/Outline/checkmark/white.png';
import img640 from '@images/UI/Outline/checkmark/white@2x.png';
import img641 from '@images/UI/Outline/checkmark/white@3x.png';
import img642 from '@images/UI/Outline/checkmark/black.png';
import img643 from '@images/UI/Outline/checkmark/black@2x.png';
import img644 from '@images/UI/Outline/checkmark/black@3x.png';
import img645 from '@images/UI/Outline/checkmark/red.png';
import img646 from '@images/UI/Outline/checkmark/red@2x.png';
import img647 from '@images/UI/Outline/checkmark/red@3x.png';
import img648 from '@images/UI/Outline/checkmark/green.png';
import img649 from '@images/UI/Outline/checkmark/green@2x.png';
import img650 from '@images/UI/Outline/checkmark/green@3x.png';
import img651 from '@images/UI/Outline/message-circle/black.png';
import img652 from '@images/UI/Outline/message-circle/black@2x.png';
import img653 from '@images/UI/Outline/message-circle/black@3x.png';
import img654 from '@images/UI/Outline/message-circle/red.png';
import img655 from '@images/UI/Outline/message-circle/red@2x.png';
import img656 from '@images/UI/Outline/message-circle/red@3x.png';
import img657 from '@images/UI/Outline/options-2/black.png';
import img658 from '@images/UI/Outline/options-2/black@2x.png';
import img659 from '@images/UI/Outline/options-2/black@3x.png';
import img660 from '@images/UI/Outline/options-2/ultraDG.png';
import img661 from '@images/UI/Outline/options-2/ultraDG@2x.png';
import img662 from '@images/UI/Outline/options-2/ultraDG@3x.png';
import img663 from '@images/UI/Outline/thumbs-up/pink.png';
import img664 from '@images/UI/Outline/thumbs-up/pink@2x.png';
import img665 from '@images/UI/Outline/thumbs-up/pink@3x.png';
import img666 from '@images/UI/Outline/thumbs-up/darkGrey.png';
import img667 from '@images/UI/Outline/thumbs-up/darkGrey@2x.png';
import img668 from '@images/UI/Outline/thumbs-up/darkGrey@3x.png';
import img669 from '@images/UI/Outline/thumbs-up/black.png';
import img670 from '@images/UI/Outline/thumbs-up/black@2x.png';
import img671 from '@images/UI/Outline/thumbs-up/black@3x.png';
import img672 from '@images/UI/Outline/thumbs-up/red.png';
import img673 from '@images/UI/Outline/thumbs-up/red@2x.png';
import img674 from '@images/UI/Outline/thumbs-up/red@3x.png';
import img675 from '@images/UI/Outline/alert-triangle/scarlet.png';
import img676 from '@images/UI/Outline/alert-triangle/scarlet@2x.png';
import img677 from '@images/UI/Outline/alert-triangle/scarlet@3x.png';
import img678 from '@images/UI/Outline/checkmark-circle/green.png';
import img679 from '@images/UI/Outline/checkmark-circle/green@2x.png';
import img680 from '@images/UI/Outline/checkmark-circle/green@3x.png';
import img681 from '@images/UI/Outline/trophy/aubergine.png';
import img682 from '@images/UI/Outline/trophy/aubergine@2x.png';
import img683 from '@images/UI/Outline/trophy/aubergine@3x.png';
import img684 from '@images/UI/Outline/truck/crimson.png';
import img685 from '@images/UI/Outline/truck/crimson@2x.png';
import img686 from '@images/UI/Outline/truck/crimson@3x.png';
import img687 from '@images/UI/Outline/user-community/aubergine.png';
import img688 from '@images/UI/Outline/user-community/aubergine@2x.png';
import img689 from '@images/UI/Outline/user-community/aubergine@3x.png';
import img690 from '@images/UI/Outline/instance/crimson.png';
import img691 from '@images/UI/Outline/instance/crimson@2x.png';
import img692 from '@images/UI/Outline/instance/crimson@3x.png';
import img693 from '@images/UI/Outline/target/aubergine.png';
import img694 from '@images/UI/Outline/target/aubergine@2x.png';
import img695 from '@images/UI/Outline/target/aubergine@3x.png';
import img696 from '@images/UI/Outline/restaurant/crimson.png';
import img697 from '@images/UI/Outline/restaurant/crimson@2x.png';
import img698 from '@images/UI/Outline/restaurant/crimson@3x.png';
import img699 from '@images/UI/Outline/arrow-ios-left/darkGrey.png';
import img700 from '@images/UI/Outline/arrow-ios-left/darkGrey@2x.png';
import img701 from '@images/UI/Outline/arrow-ios-left/darkGrey@3x.png';
import img702 from '@images/UI/Outline/arrow-ios-right/darkGrey.png';
import img703 from '@images/UI/Outline/arrow-ios-right/darkGrey@2x.png';
import img704 from '@images/UI/Outline/arrow-ios-right/darkGrey@3x.png';
import img705 from '@images/UI/Outline/arrow-right/darkGrey.png';
import img706 from '@images/UI/Outline/arrow-right/darkGrey@2x.png';
import img707 from '@images/UI/Outline/arrow-right/darkGrey@3x.png';

export default {
  Outline: {
    leaf: {
      green: {
        x1: img0,
        x2: img1,
        x3: img2
      },
      red: {
        x1: img3,
        x2: img4,
        x3: img5
      }
    },
    cash: {
      contrastGrey: {
        x1: img6,
        x2: img7,
        x3: img8
      }
    },
    fish: {
      red: {
        x1: img9,
        x2: img10,
        x3: img11
      },
      black: {
        x1: img12,
        x2: img13,
        x3: img14
      }
    },
    bar: {
      black: {
        x1: img15,
        x2: img16,
        x3: img17
      }
    },
    funnel: {
      black: {
        x1: img18,
        x2: img19,
        x3: img20
      }
    },
    swap: {
      black: {
        x1: img21,
        x2: img22,
        x3: img23
      }
    },
    ruble: {
      white: {
        x1: img24,
        x2: img25,
        x3: img26
      }
    },
    arrowLeft: {
      darkGrey: {
        x1: img27,
        x2: img28,
        x3: img29
      }
    },
    arrowRight: {
      black: {
        x1: img30,
        x2: img31,
        x3: img32
      },
      darkGrey: {
        x1: img705,
        x2: img706,
        x3: img707
      }
    },
    rubleCircle: {
      yellow: {
        x1: img33,
        x2: img34,
        x3: img35
      }
    },
    arrowLongRight2: {
      red: {
        x1: img36,
        x2: img37,
        x3: img38
      }
    },
    arrowLongRight: {
      black: {
        x1: img39,
        x2: img40,
        x3: img41
      },
      yellow: {
        x1: img42,
        x2: img43,
        x3: img44
      }
    },
    arrowCircleDown: {
      black: {
        x1: img45,
        x2: img46,
        x3: img47
      },
      red: {
        x1: img48,
        x2: img49,
        x3: img50
      }
    },
    ng: {
      white: {
        x1: img51,
        x2: img52,
        x3: img53
      },
      black: {
        x1: img54,
        x2: img55,
        x3: img56
      }
    },
    flip2: {
      black: {
        x1: img57,
        x2: img58,
        x3: img59
      }
    },
    at: {
      black: {
        x1: img60,
        x2: img61,
        x3: img62
      }
    },
    print: {
      black: {
        x1: img63,
        x2: img64,
        x3: img65
      },
      white: {
        x1: img66,
        x2: img67,
        x3: img68
      }
    },
    copyFile: {
      darkGrey: {
        x1: img69,
        x2: img70,
        x3: img71
      }
    },
    maximize: {
      white: {
        x1: img72,
        x2: img73,
        x3: img74
      }
    },
    pauseCircle: {
      white: {
        x1: img75,
        x2: img76,
        x3: img77
      }
    },
    playCircle: {
      black: {
        x1: img78,
        x2: img79,
        x3: img80
      },
      white: {
        x1: img81,
        x2: img82,
        x3: img83
      }
    },
    list: {
      black: {
        x1: img84,
        x2: img85,
        x3: img86
      },
      red: {
        x1: img87,
        x2: img88,
        x3: img89
      }
    },
    video: {
      white: {
        x1: img90,
        x2: img91,
        x3: img92
      },
      black: {
        x1: img93,
        x2: img94,
        x3: img95
      },
      red: {
        x1: img96,
        x2: img97,
        x3: img98
      }
    },
    lock: {
      midGrey: {
        x1: img99,
        x2: img100,
        x3: img101
      }
    },
    crab: {
      white: {
        x1: img102,
        x2: img103,
        x3: img104
      },
      red: {
        x1: img105,
        x2: img106,
        x3: img107
      }
    },
    allDone: {
      black: {
        x1: img108,
        x2: img109,
        x3: img110
      }
    },
    bell: {
      black: {
        x1: img111,
        x2: img112,
        x3: img113
      },
      midGrey: {
        x1: img114,
        x2: img115,
        x3: img116
      },
      red: {
        x1: img117,
        x2: img118,
        x3: img119
      },
      ultraDG: {
        x1: img120,
        x2: img121,
        x3: img122
      }
    },
    fire: {
      ultraDG: {
        x1: img123,
        x2: img124,
        x3: img125
      }
    },
    qr: {
      pink: {
        x1: img126,
        x2: img127,
        x3: img128
      },
      black: {
        x1: img129,
        x2: img130,
        x3: img131
      }
    },
    fileText: {
      darkGrey: {
        x1: img132,
        x2: img133,
        x3: img134
      },
      black: {
        x1: img135,
        x2: img136,
        x3: img137
      },
      red: {
        x1: img138,
        x2: img139,
        x3: img140
      },
      white: {
        x1: img141,
        x2: img142,
        x3: img143
      }
    },
    clipboard: {
      pink: {
        x1: img144,
        x2: img145,
        x3: img146
      }
    },
    person: {
      pink: {
        x1: img147,
        x2: img148,
        x3: img149
      }
    },
    personMobile: {
      black: {
        x1: personMobileBlack,
        x2: personMobileBlack2x,
        x3: personMobileBlack3x
      },
      grey: {
        x1: personMobileGrey,
        x2: personMobileGrey2x,
        x3: personMobileGrey3x
      },
      filled: {
        x1: personMobileFilled,
        x2: personMobileFilled2x,
        x3: personMobileFilled3x
      },
      active: {
        x1: personMobileActive,
        x2: personMobileActive2x,
        x3: personMobileActive3x
      },
      greyNotification: {
        x1: personMobileGreyNotification,
        x2: personMobileGreyNotification2x,
        x3: personMobileGreyNotification3x
      },
      blackNotification: {
        x1: personMobileBlackNotification,
        x2: personMobileBlackNotification2x,
        x3: personMobileBlackNotification3x
      }
    },
    personDone: {
      black: {
        x1: img150,
        x2: img151,
        x3: img152
      },
      yellow: {
        x1: img153,
        x2: img154,
        x3: img155
      }
    },
    cutlery: {
      darkGrey: {
        x1: img156,
        x2: img157,
        x3: img158
      }
    },
    percent: {
      black: {
        x1: img159,
        x2: img160,
        x3: img161
      },
      red: {
        x1: img162,
        x2: img163,
        x3: img164
      },
      green: {
        x1: img165,
        x2: img166,
        x3: img167
      },
      ultraDG: {
        x1: img168,
        x2: img169,
        x3: img170
      }
    },
    briefcase: {
      black: {
        x1: img171,
        x2: img172,
        x3: img173
      }
    },
    qmCircle: {
      white: {
        x1: img174,
        x2: img175,
        x3: img176
      },
      darkGrey: {
        x1: img177,
        x2: img178,
        x3: img179
      },
      midGrey: {
        x1: img180,
        x2: img181,
        x3: img182
      },
      black: {
        x1: img183,
        x2: img184,
        x3: img185
      },
      red: {
        x1: img186,
        x2: img187,
        x3: img188
      }
    },
    chiefHat: {
      white: {
        x1: img189,
        x2: img190,
        x3: img191
      },
      black: {
        x1: img192,
        x2: img193,
        x3: img194
      },
      red: {
        x1: img195,
        x2: img196,
        x3: img197
      }
    },
    rotateCW: {
      black: {
        x1: img198,
        x2: img199,
        x3: img200
      },
      red: {
        x1: img201,
        x2: img202,
        x3: img203
      }
    },
    menu: {
      white: {
        x1: img204,
        x2: img205,
        x3: img206
      },
      black: {
        x1: img207,
        x2: img208,
        x3: img209
      },
      ultraDG: {
        x1: img210,
        x2: img211,
        x3: img212
      }
    },
    copy: {
      black: {
        x1: img213,
        x2: img214,
        x3: img215
      },
      red: {
        x1: img216,
        x2: img217,
        x3: img218
      }
    },
    cube: {
      white: {
        x1: img219,
        x2: img220,
        x3: img221
      }
    },
    email: {
      black: {
        x1: img222,
        x2: img223,
        x3: img224
      },
      white: {
        x1: img225,
        x2: img226,
        x3: img227
      },
      ultraDG: {
        x1: img228,
        x2: img229,
        x3: img230
      }
    },
    review: {
      ultraDG: {
        x1: img231,
        x2: img232,
        x3: img233
      }
    },
    icecream: {
      red: {
        x1: img234,
        x2: img235,
        x3: img236
      },
      ultraDG: {
        x1: img237,
        x2: img238,
        x3: img239
      }
    },
    bookmark: {
      black: {
        x1: img240,
        x2: img241,
        x3: img242
      },
      white: {
        x1: img243,
        x2: img244,
        x3: img245
      },
      grey: {
        x1: img246,
        x2: img247,
        x3: img248
      },
      red: {
        x1: img249,
        x2: img250,
        x3: img251
      },
      darkGrey: {
        x1: img252,
        x2: img253,
        x3: img254
      }
    },
    heart: {
      white: {
        x1: img255,
        x2: img256,
        x3: img257
      },
      midGrey: {
        x1: img258,
        x2: img259,
        x3: img260
      },
      pink: {
        x1: img261,
        x2: img262,
        x3: img263
      },
      black: {
        x1: img264,
        x2: img265,
        x3: img266
      },
      red: {
        x1: img267,
        x2: img268,
        x3: img269
      }
    },
    heartMobile: {
      black: {
        x1: heartMobileBlack,
        x2: heartMobileBlack2x,
        x3: heartMobileBlack3x
      },
      grey: {
        x1: heartMobileGrey,
        x2: heartMobileGrey2x,
        x3: heartMobileGrey3x
      },
      filled: {
        x1: heartMobileFilled,
        x2: heartMobileFilled2x,
        x3: heartMobileFilled3x
      },
      active: {
        x1: heartMobileActive,
        x2: heartMobileActive2x,
        x3: heartMobileActive3x
      }
    },
    chevronDown: {
      white: {
        x1: img270,
        x2: img271,
        x3: img272
      },
      black: {
        x1: img273,
        x2: img274,
        x3: img275
      },
      midGrey: {
        x1: img276,
        x2: img277,
        x3: img278
      },
      red: {
        x1: img279,
        x2: img280,
        x3: img281
      },
      darkGrey: {
        x1: img282,
        x2: img283,
        x3: img284
      }
    },
    chevronLeft: {
      white: {
        x1: img285,
        x2: img286,
        x3: img287
      },
      black: {
        x1: img288,
        x2: img289,
        x3: img290
      },
      lightGrey: {
        x1: img291,
        x2: img292,
        x3: img293
      },
      red: {
        x1: img294,
        x2: img295,
        x3: img296
      },
      darkGrey: {
        x1: img297,
        x2: img298,
        x3: img299
      }
    },
    chevronRight: {
      white: {
        x1: img300,
        x2: img301,
        x3: img302
      },
      black: {
        x1: img303,
        x2: img304,
        x3: img305
      },
      lightGrey: {
        x1: img306,
        x2: img307,
        x3: img308
      },
      red: {
        x1: img309,
        x2: img310,
        x3: img311
      },
      darkGrey: {
        x1: img312,
        x2: img313,
        x3: img314
      }
    },
    search: {
      black: {
        x1: img315,
        x2: img316,
        x3: img317
      },
      darkGrey: {
        x1: img318,
        x2: img319,
        x3: img320
      },
      red: {
        x1: img321,
        x2: img322,
        x3: img323
      }
    },
    searchMobile: {
      black: {
        x1: searchMobileBlack,
        x2: searchMobileBlack2x,
        x3: searchMobileBlack3x
      },
      grey: {
        x1: searchMobileGrey,
        x2: searchMobileGrey2x,
        x3: searchMobileGrey3x
      },
      filled: {
        x1: searchMobileFilled,
        x2: searchMobileFilled2x,
        x3: searchMobileFilled3x
      },
      active: {
        x1: searchMobileActive,
        x2: searchMobileActive2x,
        x3: searchMobileActive3x
      }
    },
    headphones: {
      black: {
        x1: img324,
        x2: img325,
        x3: img326
      }
    },
    home: {
      black: {
        x1: img327,
        x2: img328,
        x3: img329
      },
      contrastGrey: {
        x1: img330,
        x2: img331,
        x3: img332
      }
    },
    homeMobile: {
      black: {
        x1: homeMobileBlack,
        x2: homeMobileBlack2x,
        x3: homeMobileBlack3x
      },
      grey: {
        x1: homeMobileGrey,
        x2: homeMobileGrey2x,
        x3: homeMobileGrey3x
      },
      filled: {
        x1: homeMobileFilled,
        x2: homeMobileFilled2x,
        x3: homeMobileFilled3x
      },
      active: {
        x1: homeMobileActive,
        x2: homeMobileActive2x,
        x3: homeMobileActive3x
      }
    },
    gift: {
      black: {
        x1: img333,
        x2: img334,
        x3: img335
      },
      red: {
        x1: img336,
        x2: img337,
        x3: img338
      }
    },
    knife: {
      black: {
        x1: img339,
        x2: img340,
        x3: img341
      }
    },
    grid3: {
      black: {
        x1: img342,
        x2: img343,
        x3: img344
      },
      ultraDG: {
        x1: img345,
        x2: img346,
        x3: img347
      }
    },
    gridMobile: {
      black: {
        x1: gridMobileBlack,
        x2: gridMobileBlack2x,
        x3: gridMobileBlack3x
      },
      grey: {
        x1: gridMobileGrey,
        x2: gridMobileGrey2x,
        x3: gridMobileGrey3x
      },
      filled: {
        x1: gridMobileFilled,
        x2: gridMobileFilled2x,
        x3: gridMobileFilled3x
      },
      active: {
        x1: gridMobileActive,
        x2: gridMobileActive2x,
        x3: gridMobileActive3x
      }
    },
    undo: {
      black: {
        x1: img348,
        x2: img349,
        x3: img350
      },
      darkGrey: {
        x1: img351,
        x2: img352,
        x3: img353
      },
      red: {
        x1: img354,
        x2: img355,
        x3: img356
      }
    },
    edit: {
      red: {
        x1: img357,
        x2: img358,
        x3: img359
      },
      black: {
        x1: img360,
        x2: img361,
        x3: img362
      },
      green: {
        x1: img363,
        x2: img364,
        x3: img365
      },
      darkGrey: {
        x1: img366,
        x2: img367,
        x3: img368
      }
    },
    edit2: {
      black: {
        x1: img369,
        x2: img370,
        x3: img371
      },
      red: {
        x1: img372,
        x2: img373,
        x3: img374
      }
    },
    trash2: {
      black: {
        x1: img375,
        x2: img376,
        x3: img377
      },
      darkGrey: {
        x1: img378,
        x2: img379,
        x3: img380
      },
      red: {
        x1: img381,
        x2: img382,
        x3: img383
      },
      grey: {
        x1: img384,
        x2: img385,
        x3: img386
      },
      ultraDG: {
        x1: img387,
        x2: img388,
        x3: img389
      }
    },
    star: {
      black: {
        x1: img390,
        x2: img391,
        x3: img392
      },
      darkGrey: {
        x1: img393,
        x2: img394,
        x3: img395
      },
      red: {
        x1: img396,
        x2: img397,
        x3: img398
      }
    },
    refresh: {
      pink: {
        x1: img399,
        x2: img400,
        x3: img401
      },
      black: {
        x1: img402,
        x2: img403,
        x3: img404
      },
      darkGrey: {
        x1: img405,
        x2: img406,
        x3: img407
      },
      white: {
        x1: img408,
        x2: img409,
        x3: img410
      }
    },
    minus: {
      udg: {
        x1: img411,
        x2: img412,
        x3: img413
      },
      white: {
        x1: img414,
        x2: img415,
        x3: img416
      },
      black: {
        x1: img417,
        x2: img418,
        x3: img419
      }
    },
    plus: {
      black: {
        x1: img420,
        x3: img421,
        x2: img422
      },
      darkGrey: {
        x1: img423,
        x3: img424,
        x2: img425
      },
      darkRed: {
        x1: img426,
        x2: img427,
        x3: img428
      },
      white: {
        x1: img429,
        x2: img430,
        x3: img431
      }
    },
    send: {
      white: {
        x1: img432,
        x2: img433,
        x3: img434
      }
    },
    camera: {
      darkGrey: {
        x1: img435,
        x2: img436,
        x3: img437
      },
      white: {
        x1: img438,
        x2: img439,
        x3: img440
      }
    },
    eyeOff2: {
      white: {
        x1: img441,
        x2: img442,
        x3: img443
      }
    },
    eye: {
      midGrey: {
        x1: img444,
        x2: img445,
        x3: img446
      },
      black: {
        x1: img447,
        x2: img448,
        x3: img449
      },
      red: {
        x1: img450,
        x2: img451,
        x3: img452
      }
    },
    eyeOff: {
      midGrey: {
        x1: img453,
        x2: img454,
        x3: img455
      }
    },
    close: {
      red: {
        x1: img456,
        x2: img457,
        x3: img458
      },
      midGrey: {
        x1: img459,
        x2: img460,
        x3: img461
      },
      white: {
        x1: img462,
        x2: img463,
        x3: img464
      },
      darkGrey: {
        x1: img465,
        x2: img466,
        x3: img467
      }
    },
    info: {
      white: {
        x1: img468,
        x2: img469,
        x3: img470
      },
      pink: {
        x1: img471,
        x2: img472,
        x3: img473
      },
      red: {
        x1: img474,
        x2: img475,
        x3: img476
      },
      darkRed: {
        x1: img477,
        x2: img478,
        x3: img479
      },
      black: {
        x1: img480,
        x2: img481,
        x3: img482
      }
    },
    bonus: {
      pink: {
        x1: img483,
        x2: img484,
        x3: img485
      },
      red: {
        x1: img486,
        x2: img487,
        x3: img488
      },
      darkRed: {
        x1: img489,
        x2: img490,
        x3: img491
      },
      black: {
        x1: img492,
        x2: img493,
        x3: img494
      },
      white: {
        x1: img495,
        x2: img496,
        x3: img497
      },
      gold: {
        x1: img498,
        x2: img499,
        x3: img500
      }
    },
    shield: {
      gold: {
        x1: img501,
        x2: img502,
        x3: img503
      },
      black: {
        x1: img504,
        x2: img505,
        x3: img506
      }
    },
    arrowDown: {
      black: {
        x1: img507,
        x2: img508,
        x3: img509
      }
    },
    arrowIosLeft: {
      darkGrey: {
        x1: img699,
        x2: img700,
        x3: img701
      },
      midGrey: {
        x1: img510,
        x2: img511,
        x3: img512
      },
      red: {
        x1: img513,
        x2: img514,
        x3: img515
      },
      lightGrey: {
        x1: img516,
        x2: img517,
        x3: img518
      },
      black: {
        x1: img519,
        x2: img520,
        x3: img521
      }
    },
    arrowIosRight: {
      darkGrey: {
        x1: img702,
        x2: img703,
        x3: img704
      },
      midGrey: {
        x1: img522,
        x2: img523,
        x3: img524
      },
      red: {
        x1: img525,
        x2: img526,
        x3: img527
      },
      lightGrey: {
        x1: img528,
        x2: img529,
        x3: img530
      },
      black: {
        x1: img531,
        x2: img532,
        x3: img533
      },
      violet: {
        x1: img534,
        x2: img535,
        x3: img536
      }
    },
    alertTriangle: {
      black: {
        x1: img537,
        x2: img538,
        x3: img539
      },
      scarlet: {
        x1: img675,
        x2: img676,
        x3: img677
      }
    },
    alertCircle: {
      black: {
        x1: img540,
        x2: img541,
        x3: img542
      }
    },
    share: {
      red: {
        x1: img543,
        x2: img544,
        x3: img545
      },
      darkGrey: {
        x1: img546,
        x2: img547,
        x3: img548
      },
      black: {
        x1: img549,
        x2: img550,
        x3: img551
      },
      white: {
        x1: img552,
        x2: img553,
        x3: img554
      }
    },
    shoppingCart: {
      black: {
        x1: img555,
        x2: img556,
        x3: img557
      },
      ultraDG: {
        x1: img558,
        x2: img559,
        x3: img560
      }
    },
    shoppingCartMobile: {
      black: {
        x1: shoppingCartMobileBlack,
        x2: shoppingCartMobileBlack2x,
        x3: shoppingCartMobileBlack3x
      },
      grey: {
        x1: shoppingCartMobileGrey,
        x2: shoppingCartMobileGrey2x,
        x3: shoppingCartMobileGrey3x
      },
      filled: {
        x1: shoppingCartMobileFilled,
        x2: shoppingCartMobileFilled2x,
        x3: shoppingCartMobileFilled3x
      },
      active: {
        x1: shoppingCartMobileActive,
        x2: shoppingCartMobileActive2x,
        x3: shoppingCartMobileActive3x
      }
    },
    broccoli: {
      ultraDG: {
        x1: img561,
        x2: img562,
        x3: img563
      }
    },
    pin: {
      black: {
        x1: img564,
        x2: img565,
        x3: img566
      },
      white: {
        x1: img567,
        x2: img568,
        x3: img569
      }
    },
    clock: {
      black: {
        x1: img570,
        x2: img571,
        x3: img572
      },
      red: {
        x1: img573,
        x2: img574,
        x3: img575
      },
      contrastGrey: {
        x1: img576,
        x2: img577,
        x3: img578
      }
    },
    timer: {
      black: {
        x1: img579,
        x2: img580,
        x3: img581
      }
    },
    award: {
      black: {
        x1: img582,
        x2: img583,
        x3: img584
      }
    },
    phoneCall: {
      pink: {
        x1: img585,
        x2: img586,
        x3: img587
      },
      black: {
        x1: img588,
        x2: img589,
        x3: img590
      }
    },
    smile: {
      red: {
        x1: img591,
        x2: img592,
        x3: img593
      },
      black: {
        x1: img594,
        x2: img595,
        x3: img596
      }
    },
    smartphone: {
      black: {
        x1: img597,
        x2: img598,
        x3: img599
      },
      yellow: {
        x1: img600,
        x2: img601,
        x3: img602
      }
    },
    calendar: {
      black: {
        x1: img603,
        x2: img604,
        x3: img605
      },
      midGrey: {
        x1: img606,
        x2: img607,
        x3: img608
      },
      white: {
        x1: img609,
        x2: img610,
        x3: img611
      }
    },
    car: {
      red: {
        x1: img612,
        x2: img613,
        x3: img614
      },
      black: {
        x1: img615,
        x2: img616,
        x3: img617
      }
    },
    inbox: {
      red: {
        x1: img618,
        x2: img619,
        x3: img620
      },
      black: {
        x1: img621,
        x2: img622,
        x3: img623
      }
    },
    checkmarkCircle: {
      red: {
        x1: img624,
        x2: img625,
        x3: img626
      },
      black: {
        x1: img627,
        x2: img628,
        x3: img629
      },
      green: {
        x1: img678,
        x2: img679,
        x3: img680
      }
    },
    checkmarkBold: {
      violet: {
        x1: img630,
        x2: img631,
        x3: img632
      }
    },
    checkmark: {
      violet: {
        x1: img633,
        x2: img634,
        x3: img635
      },
      darkGrey: {
        x1: img636,
        x2: img637,
        x3: img638
      },
      white: {
        x1: img639,
        x2: img640,
        x3: img641
      },
      black: {
        x1: img642,
        x2: img643,
        x3: img644
      },
      red: {
        x1: img645,
        x2: img646,
        x3: img647
      },
      green: {
        x1: img648,
        x2: img649,
        x3: img650
      }
    },
    messageCircle: {
      black: {
        x1: img651,
        x2: img652,
        x3: img653
      },
      red: {
        x1: img654,
        x2: img655,
        x3: img656
      }
    },
    options2: {
      black: {
        x1: img657,
        x2: img658,
        x3: img659
      },
      ultraDG: {
        x1: img660,
        x2: img661,
        x3: img662
      }
    },
    thumbsUp: {
      pink: {
        x1: img663,
        x2: img664,
        x3: img665
      },
      darkGrey: {
        x1: img666,
        x2: img667,
        x3: img668
      },
      black: {
        x1: img669,
        x2: img670,
        x3: img671
      },
      red: {
        x1: img672,
        x2: img673,
        x3: img674
      }
    },
    trophy: {
      aubergine: {
        x1: img681,
        x2: img682,
        x3: img683
      }
    },
    truck: {
      crimson: {
        x1: img684,
        x2: img685,
        x3: img686
      }
    },
    userCommunity: {
      aubergine: {
        x1: img687,
        x2: img688,
        x3: img689
      }
    },
    instance: {
      crimson: {
        x1: img690,
        x2: img691,
        x3: img692
      }
    },
    target: {
      aubergine: {
        x1: img693,
        x2: img694,
        x3: img695
      }
    },
    restaurant: {
      crimson: {
        x1: img696,
        x2: img697,
        x3: img698
      }
    }
  }
};
